import React from 'react';
import { useTranslation } from 'next-i18next';
import { IControlButtonProps } from '../control-base';
import s from './styles.module.scss';
import classNames from 'classnames';

const OpenButton: React.FC<IControlButtonProps> = (props) => {
  const { t: tButtons } = useTranslation('buttons');
  const { onClick, text = tButtons('open'), className = '' } = props;

  const btnClassNames = classNames(s['btn'], className);

  return (
    <button onClick={onClick} className={btnClassNames}>
      {text}
    </button>
  );
};

export default OpenButton;
